import { ChangeEvent, KeyboardEvent } from 'react';
import { textoParaValor, valorParaTexto } from '../utils/Utils';
import styles from './MoneyInput.module.css';

export type MoneyInputProps = {
  label?: string;
  valor: number;
  onChange: (valor: number) => void;
  placeholder?: string;
  erro?: string;
  dica?: string;
  obrigatorio?: boolean;
  autoFocus?: boolean;
  onEnter?: () => void;
};

/**
 * Campo monetário pt-BR com prefixo fixo "R$". Máscara de centavos: digitar
 * preenche da direita para a esquerda (5 → 0,05 → 0,50 → 5,00).
 */
export default function MoneyInput({
  label,
  valor,
  onChange,
  placeholder,
  erro,
  dica,
  obrigatorio,
  autoFocus,
  onEnter
}: MoneyInputProps) {
  // valorParaTexto devolve "R$ 1.234,56"; o prefixo é renderizado à parte.
  const texto = valorParaTexto(valor, true).replace(/^R\$\s*/, '');

  const aoDigitar = (evento: ChangeEvent<HTMLInputElement>) => {
    const numero = textoParaValor(evento.target.value);
    onChange(Number.isNaN(numero) ? 0 : numero);
  };

  const aoTeclar = (evento: KeyboardEvent<HTMLInputElement>) => {
    if (evento.key === 'Enter') onEnter?.();
  };

  return (
    <label className={styles.raiz}>
      {label && (
        <span className={styles.rotulo}>
          {label}
          {obrigatorio && <span className={styles.asterisco}>*</span>}
        </span>
      )}
      <span className={`${styles.campo} ${erro ? styles.comErro : ''}`}>
        <span className={styles.prefixo}>R$</span>
        <input
          className={styles.entrada}
          type="text"
          inputMode="numeric"
          value={texto}
          onChange={aoDigitar}
          onKeyDown={aoTeclar}
          placeholder={placeholder}
          autoFocus={autoFocus}
        />
      </span>
      {erro ? (
        <span className={styles.erro}>{erro}</span>
      ) : (
        dica && <span className={styles.dica}>{dica}</span>
      )}
    </label>
  );
}
